import { render } from "./MaisAmigosCard.vue?vue&type=template&id=78458d85"
import script from "./MaisAmigosCard.vue?vue&type=script&lang=js"
export * from "./MaisAmigosCard.vue?vue&type=script&lang=js"

import "./MaisAmigosCard.vue?vue&type=style&index=0&id=78458d85&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__